//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { dispatchOrder, fetchDetail, userList } from '@/api/PMS/repair/repairManagement';
export default {
  props: ['keyValue', 'flowNum', 'showDialog'],
  data: function data() {
    return {
      propstree: {
        label: 'userTreeName',
        value: 'id',
        children: 'userList'
      },
      rules: {
        repairUserList: [{
          required: true,
          message: '请输入派工人员',
          trigger: 'blur'
        }],
        repairTime: [{
          required: true,
          message: '请选择派工时间',
          trigger: 'blur'
        }]
      },
      options: [],
      showPerson: true,
      childData: {},
      dispatchData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.dispatchData = {};
      this.loadUserList();
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue,
          flowNum: this.flowNum
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
        });
      } else {
        this.childData = {};
      }
    },
    loadUserList: function loadUserList() {
      var _this2 = this;

      userList().then(function (response) {
        _this2.options = response.data.data;
      });
    },
    handDispatch: function handDispatch() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this3.keyValue > 0) {
            _this3.dispatchData.repairId = _this3.keyValue;
            _this3.dispatchData.repairUserId = _this3.dispatchData.repairUserList[1];
            dispatchOrder(_this3.dispatchData).then(function () {
              _this3.$emit('handCancle', 'dispatchRepair');

              _this3.Alert({
                alertType: 'add',
                message: '派工成功'
              });
            });
          }
        } else {
          _this3.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', 'dispatchRepair');
    }
  }
};